export enum LanguageEnum {
  NOR = "NOR",
  ENG = "ENG"
}